import { USER_RESOURCE } from '../api/resources';

export const storeToken = (params) => (dispatch, getState, api) => api[USER_RESOURCE].token(params);

export const resetPassword = (params) => (dispatch, getState, api) =>
    api[USER_RESOURCE].resetPassword(params);
export const setPassword = (params) => (dispatch, getState, api) =>
    api[USER_RESOURCE].setPassword(params);
